import { statusText } from '@components/nearby/StatusSelectButtons'
import { useAuthContext } from '@contexts/authContext'
import { fontSize, size } from '@styles/theme'
import capitalize from '@utils/capitalize'
import styled from '@emotion/styled/macro'
import useDialog from '@hooks/useDialog'

import NearbyStatusDialog from '@components/nearby/NearbyStatusDialog'
import { PiArrowRightBold, PiInfo } from 'react-icons/pi'
import StatusIndicator from '@elements/StatusIndicator'
import { ButtonBase } from '@mui/material'

const Container = styled.div`
  position: relative;
`
const StatusLabel = styled.label``

const LabelText = styled.span`
  display: flex;
  justify-content: space-between;
  padding: 0 0 ${size(0.5)} ${size(1)};
  font-size: ${fontSize('sm')}
`

const StatusButton = styled(ButtonBase)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;
  flex-wrap: nowrap;
  gap: ${size(1.5)};

  width: 100%;
  padding: ${size(2)};
  border-radius: 12px;
  
  background-color: rgba(155,155,155, 0.2);

  font-weight: 500;
  font-size: ${fontSize('md')};
`

const ButtonRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  gap: ${size(0.5)};
`

const InfoText = styled.span`
  display: flex;
  align-items: center;
  color: lightgrey;
  font-size: ${fontSize('xs')};
  background-color: #071318;
  padding: 0 ${size(0.5)};
  border-radius: 2px;
  color: #B8E7FB;
`

const StatusText = styled.div`
  font-size: ${fontSize('sm')};
  font-weight: 400;
  color: lightgrey;
`

const RightActionArrow = styled(PiArrowRightBold)`
  position: absolute;
  right: ${size(2.5)};
`

const LookingStatusProfileFormButton = ({ tagline }) => {
  const [isStatusDialogOpen, openStatusDialog, closeStatusDialog] = useDialog('nearby_form_status_dialog', 'nearby-form-status-dialog-open')
  const { state: authState } = useAuthContext()
  const status = authState?.user?.tempStatus

  const handleOpen = (e) => {
    e.preventDefault()
    openStatusDialog()
  }

  return (
    <Container>
      <NearbyStatusDialog
        isOpen={isStatusDialogOpen}
        setClosed={closeStatusDialog}
        tagline={tagline}
      />
      <StatusLabel>
        <LabelText>
          Looking Status
          <InfoText>
            <PiInfo color='#B8E7FB' />&nbsp;
            {authState?.user?.tempStatus === 'browsing'
              ? 'Highly Recommended Setting'
              : "shows why you're here"
            }
          </InfoText>
        </LabelText>
        <StatusButton
          onClick={handleOpen}>
          <StatusIndicator size={size(6)} status={status} />
          <ButtonRight>
            <div>{capitalize(status?.replace('_', ' '))}</div>
            <StatusText>{statusText[status]}</StatusText>
          </ButtonRight>
          <RightActionArrow size={size(3)} />
        </StatusButton>
      </StatusLabel>
    </Container>
  )
}

export { LookingStatusProfileFormButton }
